import { useAuth } from '@/contexts/AuthContext';
import { SplashLoader } from '@/components/SplashLoader';

interface PermissionGuardProps {
  children: React.ReactNode;
  permission: string;
  fallback?: React.ReactNode;
}

export default function PermissionGuard({ children, permission, fallback }: PermissionGuardProps) {
  const { user, loading, checkPermission } = useAuth();

  if (loading) return <SplashLoader />;

  if (!checkPermission(permission)) {
    if (fallback) {
      return <>{fallback}</>;
    }

    // Default fallback - show a permission denied message
    return (
      <div className="flex min-h-[400px] items-center justify-center">
        <div className="text-center">
          <div className="mb-4 text-gray-400">
            <svg className="mx-auto size-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
          </div>
          <h3 className="text-sm font-medium text-gray-900">Access Restricted</h3>
          <p className="mt-1 text-sm text-gray-500">
            You don't have permission to access this feature.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
